import { HttpError } from "./HttpError";
import { ValidationError } from "./ValidationError";

export function isHttpError(error: unknown): error is HttpError {
  return error instanceof HttpError;
}

export function isValidationError(error: unknown): error is ValidationError {
  return error instanceof ValidationError;
}
